<template>
    <div
        :class="{
            'l-ss-c-filter-is-short': isShort,
            'l-ss-c-filter-toggle-is-checked': isChecked,
        }"
        class="l-ss-c-filter-toggle">
        <div
            class="l-ss-c-filter-toggle-inner"
            @click="onToggle">
            <span class="l-ss-c-filter-toggle-icon"></span>
            {{ $t(`filters.byType.${type}`).checked }}
            <c-label
                v-if="showTitle"
                :label="filterLabel"/>
        </div>
        <button
            v-if="isActiveTopFiltersPosition && isShort"
            class="l-ss-c-filters-save-button l-ss-c-button"
            @click="$emit('close-filter')">
            {{ $t('filters.applyPrice') }}
        </button>
    </div>
</template>

<script>
    import FilterMixin from './mixin';
    import CLabel from './components/label';

    export default {
        components: {
            CLabel,
        },
        mixins: [
            FilterMixin,
        ],
        props: {
            type: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                isChecked: false,
            };
        },
        watch: {
            filterValue: {
                immediate: true,
                handler(value) {
                    this.isChecked = !!value;
                },
            },
        },
        methods: {
            onToggle(event) {
                if (!this.isChecked) {
                    this.onChange({
                        field: '_is_available',
                        condition: 'equal',
                        value: 'true',
                    });
                    this.onFilterClick(event, { value: true });
                } else {
                    this.onChange();
                    this.onFilterClick(event, { value: false });
                }
            },
        },
    };
</script>